var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-container-anim"
  }, [_c('div', {
    staticClass: "svg-container"
  }, [_vm.theme.bgImg ? _c('div', {
    staticClass: "svg-wrapper",
    class: {
      'animate-active': _vm.isMouseOnForm
    },
    domProps: {
      "innerHTML": _vm._s(_vm.theme.bgImg)
    }
  }) : _vm._e()]), _vm.isShowTopLogo ? _c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "top-left-logo"
  }, [_vm.theme.topLeftLogo ? _c('img', {
    attrs: {
      "src": _vm.theme.topLeftLogo
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "top-center-logo mx-auto"
  }, [_vm.theme.topCenterLogo ? _c('img', {
    attrs: {
      "src": _vm.theme.topCenterLogo
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "top-right-logo ml-auto"
  }, [_vm.theme.topRightLogo ? _c('img', {
    attrs: {
      "src": _vm.theme.topRightLogo
    }
  }) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "login-form",
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_c('div', {
    staticClass: "login-auth-form"
  }, [_c('div', {
    staticClass: "login-card-"
  }, [_vm.formTitle ? _c('div', {
    staticClass: "w-mb-12"
  }, [_c('h3', {
    staticClass: "typo-h-24-28 troy--text",
    staticStyle: {
      "text-align": "center",
      "white-space": "pre-wrap"
    }
  }, [_vm._v(" " + _vm._s(_vm.formTitle) + " ")])]) : _vm._e(), _vm.theme.formLogo ? _c('div', {
    staticClass: "w-mb-32 text-center"
  }, [!_vm.rawLogo ? _c('img', {
    attrs: {
      "src": _vm.theme.formLogo
    }
  }) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "w-mb-24"
  }, [_c('r-input', {
    attrs: {
      "label": "Логин",
      "autocompleteInput": "",
      "error": _vm.isShowError && !_vm.isValidUserName,
      "errorMessage": !_vm.username ? 'Укажите логин' : 'Превышен лимит символов логина'
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  })], 1), _c('div', {
    staticClass: "w-mb-24"
  }, [_c('r-input', {
    attrs: {
      "label": "Пароль",
      "typeInput": "password",
      "autocompleteInput": "",
      "error": _vm.isShowError && !_vm.isValidPassword,
      "errorMessage": !_vm.password ? 'Введите пароль' : 'Превышен лимит символов пароля'
    },
    on: {
      "keypress": _vm.onKeyPress
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c('div', {
    staticClass: "w-mb-24"
  }, [_c('r-checkbox', {
    attrs: {
      "title": "Чужой компьютер"
    },
    model: {
      value: _vm.isForeign,
      callback: function ($$v) {
        _vm.isForeign = $$v;
      },
      expression: "isForeign"
    }
  })], 1), _c('r-button', {
    attrs: {
      "color": "rocky",
      "width": "wide",
      "title": "Войти",
      "is-loading": _vm.isAuthenticating
    },
    on: {
      "click": function ($event) {
        return _vm.authenticate();
      }
    }
  })], 1)])]), _c('div', {
    class: ['copyright-container', {
      'copyright-container__multi': _vm.isMultiTheme
    }]
  }, [_c('div', {
    staticClass: "mozzarella metropolis--text",
    domProps: {
      "innerHTML": _vm._s(_vm.getCopyrightText())
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }